"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Datepicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var reactstrap_1 = require("reactstrap");
var react_1 = __importDefault(require("react"));
var flatpickr_1 = __importDefault(require("flatpickr"));
var icons_1 = require("../../../icons");
require("./flatpickr-settings");
// https://flatpickr.js.org/
// tried https://github.com/haoxins/react-flatpickr but appendTo option with ref wasn't working
// calendar was appended to the body and appeared in wrong position
var Datepicker = function (_a) {
    var invalid = _a.invalid, options = _a.options, _b = _a.placeholder, placeholder = _b === void 0 ? 'Select date' : _b, valid = _a.valid, props = __rest(_a, ["invalid", "options", "placeholder", "valid"]);
    var wrapper = react_1.default.useRef(null);
    var inputGroup = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        (0, flatpickr_1.default)(inputGroup === null || inputGroup === void 0 ? void 0 : inputGroup.current, __assign({ allowInput: true, altInput: true, altFormat: 'M j, Y', wrap: true, static: true }, options));
        // fix Date24 icon position when calendar is inline
        if (options === null || options === void 0 ? void 0 : options.inline) {
            var iconParent = wrapper.current.firstChild.firstChild;
            iconParent.classList.add('position-absolute');
            var altInput = wrapper.current.querySelectorAll('input')[1]; // the second alt input, the first is hidden
            iconParent.style.height = altInput.offsetHeight + 'px'; // 40px
        }
    }, [options, valid, invalid]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ ref: wrapper, "data-cy": "flatpickr-datepicker" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ ref: inputGroup }, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.Input, __assign({ invalid: invalid, valid: valid, className: "ps-7", placeholder: placeholder, readOnly: true, "data-input": true }, props)), (0, jsx_runtime_1.jsx)(icons_1.Date24, { className: "position-absolute top-50 start-0 translate-middle-y x5-ms-2 opacity-60 pe-none" })] })) })));
};
exports.Datepicker = Datepicker;
